import { GameRequest } from '@api/selfServe';
import { SelfServeDataAccessStatus, DataAccessProvider } from '@constants/constants';

export const pendingNDARespone = (): GameRequest[] => {
  return [
    {
      id: '1',
      gameId: '1',
      category: 'Casual',
      genre: 'Puzzle',
      requestStatus: SelfServeDataAccessStatus.PENDING_NDA_CREATION,
      metadata:
        '{ "PLAY_STORE": { "marketPlace": "PLAY_STORE", "appUrl": "https://play.google.com/store/apps/details?id=com.pvx.puzzlerpro&hl=en_IN", "name": "Puzzler Pro", "icon": "https://storage.googleapis.com/pvx-prd-core-public/app/icons/PvXPuzzlerIcon.png", "developerName": "PvX Puzzler Pro LLC", "rating": "4.5star", "reviews": "80.1K reviews", "downloads": "1M+" }, "APP_STORE": { "marketPlace": "APP_STORE", "appUrl": "https://apps.apple.com/in/app/puzzlerpro/id99309054", "name": "Puzzler Pro", "icon": "https://storage.googleapis.com/pvx-prd-core-public/app/icons/PvXPuzzlerIcon.png", "developerName": "PvX Puzzler Pro LLC", "rating": "4.5", "reviews": "17743", "downloads": "downloads" } }',
      accessEmail: 'underwriting@pvxpartners.com',
      companyName: null,
      companyAddress: null,
      signingAuthorityName: null,
      signingAuthorityEmail: null,
      signingAuthorityTitle: null,
      mmp: DataAccessProvider.NONE,
    },
  ];
};
